import React, { useState, useEffect } from 'react';
import { makeStyles,Grid } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
// Components
import KenGrid from '../../global_components/KenGrid';
import KenCheckbox from '../../global_components/KenCheckbox/index';
import KenButton from '../../global_components/KenButton';
import KenLoader from '../../Components/KenLoader/index';
import KenSnackbar from '../../Components/KenSnackbar/index';

const useStyles = makeStyles((theme) => ({}));
const GradeStudents = () => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  // SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setLoading(false);
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  return (
    <>
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      {loading && <KenLoader />}

      <Grid container>Grade Student</Grid>
    </>
  );
};
export default GradeStudents;
